import { render, staticRenderFns } from "./diagnoseDetailDialog.vue?vue&type=template&id=374ec8b8&scoped=true"
import script from "./diagnoseDetailDialog.vue?vue&type=script&lang=js"
export * from "./diagnoseDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./diagnoseDetailDialog.vue?vue&type=style&index=0&id=374ec8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374ec8b8",
  null
  
)

export default component.exports